import { useMemo } from "react";
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import L from "leaflet";
import { Link } from "react-router-dom";

const statusColors = {
  verified: "#65a30d",
  pilot: "#fbbf24"
};

const buildIcon = (status) =>
  L.divIcon({
    html: `<span style="background:${statusColors[status] || "#a3e635"};" class="marker-dot"></span>`,
    className: "pointer-events-none",
    iconSize: [24, 24]
  });

const CommunityMap = ({ communities = [], center = [20, 0], zoom = 2.4, onSelect, height = "520px" }) => {
  const markers = useMemo(
    () =>
      communities.map((community) => ({
        community,
        position: [community.lat, community.lng],
        status: community.status
      })),
    [communities]
  );

  return (
    <MapContainer
      center={center}
      zoom={zoom}
      style={{ height, width: "100%", borderRadius: "1.5rem", border: "1px solid rgba(255,255,255,0.1)" }}
      minZoom={2}
      maxBounds={[[-85, -180], [85, 180]]}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a>'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {markers.map(({ community, position, status }) => (
        <Marker
          key={community.id}
          position={position}
          eventHandlers={{ click: () => onSelect?.(community) }}
          icon={buildIcon(status)}
        >
          <Popup>
            <div className="text-sm">
              <p className="font-semibold text-slate-900">{community.name}</p>
              <p className="text-xs text-slate-500">{community.city}</p>
              <Link to={`/communities/${community.id}`} className="text-brand-primary">
                Open profile
              </Link>
            </div>
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
};

export default CommunityMap;
